
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/99daysofdesign",
      function () {
        return require("private-next-pages/99daysofdesign/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/99daysofdesign"])
      });
    }
  